import { useQuery } from "@tanstack/react-query";
import { GET_SECTION_DATA } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import { useReactQueryErrorReporter } from "./use-error-reporter";

const fetchSectionsByIds = async ({ queryKey }) => {
  const [, parentIDs] = queryKey;

  const sectionPromises = parentIDs
    .filter((parentID) => !!parentID && parentID !== "null")
    .map(async (parentID) => {
      const { getSectionById } = await graphQLClient.request(GET_SECTION_DATA, {
        id: parentID,
      });
      return {
        id: getSectionById.id,
        sectionName: getSectionById.sectionName,
        contractTTL: getSectionById.contractTTL,
        parentID: getSectionById.parentID,
        shardID: getSectionById.shardID,
        path: getSectionById.path,
        climberSubscription: getSectionById.climberSubscription,
        coachSubscription: getSectionById.coachSubscription,
        sessionIDs: getSectionById.sessionIDs,
      };
    });

  return Promise.all(sectionPromises);
};

export const useGetSectionsByIds = (parentIDs) => {
  const { error, ...rest } = useQuery({
    queryKey: ["sectionsByIds", parentIDs],
    queryFn: fetchSectionsByIds,
    enabled: parentIDs.length > 0,
  });

  useReactQueryErrorReporter("Error fetching sections", error);

  return { error, ...rest };
};
